import { MenuEntry } from '@pancakeswap/uikit'
import { ContextApi } from 'contexts/Localization/types'

const config: (t: ContextApi['t']) => MenuEntry[] = (t) => [
  {
    label: t('Home'),
    icon: 'HomeIcon',
    href: '/',
  },
  {
    label: t('Trade'),
    icon: 'TradeIcon',
    items: [
      {
        label: t('Exchange'),
        href: '/swap',
      },
      {
        label: t('Liquidity'),
        href: '/pool',
      },
      
    ],
  },
  {
    label: t('Farms coming soon after pre-sale'),
    icon: 'FarmIcon',
    href: '/farms',
  },
  {
    label: t('Pools coming soon after pre-sale'),
    icon: 'PoolIcon',
    href: '/pools',
  },
  {
    label: t('Prediction (BETA)'),
    icon: 'PredictionsIcon',
    href: '/prediction',
  },
 

  {
    label: t('Teams & Profile'),
    icon: 'GroupsIcon',
    items: [
      
     
      {
        label: t('Your Profile'),
        href: '/profile',
      },
    ],
  },
 
  {
    label: t('More'),
    icon: 'MoreIcon',
    items: [
      {
        label: t('Contact'),
        href: 'https://t.me/santamaxchat',
      },
      {
        label: t('Voting'),
        href: '/voting',
      },
      
      {
        label: t('Docs'),
        href: '',
      },
      
     
    ],
  },
]

export default config
